import { filter } from "lodash";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
// material
import {
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  InputAdornment,
  Switch,
  Typography
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useFormik, Form, FormikProvider } from "formik";

import { Stack, Container, TextField, Button, Select, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
// components
import Page from "../components/Page";
import { MemberForm } from "../components/Form/Member";
import { borderRadius } from "@mui/system";
import { notification } from "src/utils/messages";
import { getInvoiceSetting, UpdateInvoiceSetting, ResetPrimeInvoiceNumber } from "src/api/updateSetting";
import CustomLoader from "src/components/CustomLoader";

export default function InvoiceSetting() {
  const navigate = useNavigate();
  const [getdata, setgetdata] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  async function fetchinvociesettinglist() {
    try {
      setIsLoading(true);
      const resp = await getInvoiceSetting();
      setIsLoading(false);
      if (resp.status == 1) {
        setgetdata(resp.data);
      }
    } catch { }
  }

  useEffect(() => {
    fetchinvociesettinglist();
  }, []);

  const onChangeFunction = (e) => {
    setgetdata({
      ...getdata,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    const settingData = {
      i_s_id: 1,
      email: getdata.email,
      address: getdata.address,
      prime_i_no: getdata.prime_i_no,
      prime_i_prefix: getdata.prime_i_prefix,
      privilege_i_no: getdata.privilege_i_no,
      privilege_i_prefix: getdata.privilege_i_prefix,
      plan_price: getdata.plan_price,
      gst_plan_price: getdata.gst_plan_price,
      gst_no: getdata.gst_no,
      pan_no: getdata.pan_no,
      website: getdata.website,
      bank_name: getdata.bank_name,
      account_holder: getdata.account_holder,
      account_no: getdata.account_no,
      ifsc_code: getdata.ifsc_code,
      branch: getdata.branch,
      account_type: getdata.account_type
    };
    const jssettingData = JSON.stringify(settingData);

    setIsLoading(true);
    const resp = await UpdateInvoiceSetting(jssettingData);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      fetchinvociesettinglist();
    }
  };

  const handleResetInvoice = async (prefixType) => {
    const resetData = {
      prefix_type: prefixType,
      prime_i_no: getdata.prime_i_no,
      privilege_i_no: getdata.privilege_i_no
    };

    setIsLoading(true);
    const resp = await ResetPrimeInvoiceNumber(JSON.stringify(resetData));
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      fetchinvociesettinglist();
    }
  };

  return (
    <Page title="Invoice Setting | Local Vocal Business Group">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Invoice Setting
          </Typography>
        </Stack>
        {isLoading ? (
          <CustomLoader />
        ) : (
          <Card style={{ marginBottom: "25px", padding: "25px" }}>
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Email"
                      name="email"
                      value={getdata?.email}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      multiline
                      autoComplete="off"
                      type="text"
                      label="Address"
                      name="address"
                      value={getdata?.address}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Prime Invoice Prefix"
                      name="prime_i_prefix"
                      value={getdata?.prime_i_prefix}
                      onChange={onChangeFunction}
                      disabled
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={1} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Prime Invoice Start From"
                      name="prime_i_no"
                      value={getdata?.prime_i_no}
                      onChange={onChangeFunction}
                      defaultValue=" "
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Button
                              onClick={() => handleResetInvoice(0)}
                              variant="contained"
                              disabled={isLoading}
                              size="small"
                            >
                              Reset
                            </Button>
                          </InputAdornment>
                        )
                      }}
                    />
                    <Typography variant="caption" color="textSecondary" style={{ marginLeft: "5px" }}>
                      Last Reset Date: {getdata?.prime_i_no_reset_date || "N/A"}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Privilege Invoice Prefix"
                      name="privilege_i_prefix"
                      value={getdata?.privilege_i_prefix}
                      disabled
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={1} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Privilege Invoice Start From"
                      name="privilege_i_no"
                      value={getdata?.privilege_i_no}
                      onChange={onChangeFunction}
                      defaultValue=" "
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Button
                              onClick={() => handleResetInvoice(1)}
                              variant="contained"
                              disabled={isLoading}
                              size="small"
                            >
                              Reset
                            </Button>
                          </InputAdornment>
                        )
                      }}
                    />
                    <Typography variant="caption" color="textSecondary" style={{ marginLeft: "5px" }}>
                      Last Reset Date: {getdata?.privilege_i_no_reset_date || "N/A"}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Price"
                      name="plan_price"
                      value={getdata?.plan_price}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="GST Price"
                      name="gst_plan_price"
                      value={getdata?.gst_plan_price}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="GST No"
                      name="gst_no"
                      value={getdata?.gst_no}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="PAN No"
                      name="pan_no"
                      value={getdata?.pan_no}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Website"
                      name="website"
                      value={getdata?.website}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Bank Name"
                      name="bank_name"
                      value={getdata?.bank_name}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Account Holder"
                      name="account_holder"
                      value={getdata?.account_holder}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Account No"
                      name="account_no"
                      value={getdata?.account_no}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="IFSC Code"
                      name="ifsc_code"
                      value={getdata?.ifsc_code}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Branch"
                      name="branch"
                      value={getdata?.branch}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Account Type"
                      name="account_type"
                      value={getdata?.account_type}
                      onChange={onChangeFunction}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
            <Button
              onClick={handleSubmit}
              style={{ marginTop: "15px" }}
              variant="contained"
              disabled={isLoading}
              startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
            >
              Update
            </Button>
          </Card>
        )}
      </Container>
    </Page>
  );
}
